import ApiClient from '../../common/utils/apiClient';
import updateAuthToken from '../../common/utils/updateAuthToken';

export const actionTypes = {
    SET_EXTERNAL_ACCOUNT_URL: 'SET_EXTERNAL_ACCOUNT_URL',
    SET_EXTERNAL_ACCOUNT_ERROR: 'SET_EXTERNAL_ACCOUNT_ERROR',
    CLEAR_EXTERNAL_ACCOUNT_DATA: 'CLEAR_EXTERNAL_ACCOUNT_DATA',
};

export const setExternalAccountUrl = externalAccountUrl => ({
    type: actionTypes.SET_EXTERNAL_ACCOUNT_URL,
    externalAccountUrl,
});

export const setIsExternalAccountError = () => ({
    type: actionTypes.SET_EXTERNAL_ACCOUNT_ERROR,
});

export const getExternalAccountUrl = bookie => dispatch => (
    ApiClient.getExternalAccountUrl(bookie)
    .then((res) => {
        updateAuthToken(res.headers);
        if (
            res.status === 200 &&
            res.data &&
            res.data.data &&
            res.data.data[0] &&
            res.data.data[0].attributes
        ) {
            return dispatch(setExternalAccountUrl(
                res.data.data[0].attributes.bookmaker_url,
            ));
        }
        return Promise.reject(res);
    })
    .catch(() => (
        dispatch(setIsExternalAccountError())
    ))
)

export const clearExternalAccountData = () => ({
    type: actionTypes.CLEAR_EXTERNAL_ACCOUNT_DATA,
});



// WEBPACK FOOTER //
// /src/js/common/externalAccount/externalAccount.actions.js